import api from "@/lib/axios";
import { ApiResponse } from "@/types/response";
import { ProductCategory, ProductCategoryFilters } from "@/types/types";

export type ProductCategoryListResponseData = {
  items: ProductCategory[];
  meta: {
    totalItems: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
};

export const productCategoriesApi = {
  buildFormData: (payload: Record<string, unknown>) => {
    const formData = new FormData();

    Object.keys(payload).forEach((key) => {
      const val = payload[key];
      if (val !== undefined && val !== null) {
        if (val instanceof File || val instanceof Blob) {
          formData.append(key, val);
        } else if (typeof val === "object") {
          formData.append(key, JSON.stringify(val));
        } else {
          formData.append(key, val.toString());
        }
      }
    });

    return formData;
  },

  getCategories: async (
    filters: ProductCategoryFilters
  ): Promise<ApiResponse<ProductCategoryListResponseData>> => {
    const response = await api.get("/product-categories", { params: filters });
    return response.data;
  },

  getCategoryById: async (id: string): Promise<ApiResponse<ProductCategory>> => {
    const response = await api.get(`/product-categories/${id}`);
    return response.data;
  },

  getCategoryBySlug: async (slug: string): Promise<ApiResponse<ProductCategory>> => {
    const response = await api.get(`/product-categories/slug/${slug}`);
    return response.data;
  },

  createCategory: async (payload: Record<string, unknown>): Promise<ApiResponse<ProductCategory>> => {
    const response = await api.post(
      "/product-categories",
      productCategoriesApi.buildFormData(payload),
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  updateCategory: async ({
    id,
    payload,
  }: {
    id: string;
    payload: Record<string, unknown>;
  }): Promise<ApiResponse<ProductCategory>> => {
    const response = await api.patch(
      `/product-categories/${id}`,
      productCategoriesApi.buildFormData(payload),
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  deleteCategory: async (id: string): Promise<ApiResponse<void>> => {
    const response = await api.delete(`/product-categories/${id}`);
    return response.data;
  },
};
